import { pages } from '../../utils/common';
import { IAppNavigationMenuItem } from './components.interfaces';

const generateNavigationItem = (pageItem: any): IAppNavigationMenuItem => {
  return {
    title: pageItem.title,
    ...(pageItem.icon && { icon: pageItem.icon }),
    pageToNavigate: pageItem.path,
    ...(pageItem?.subPages && {
      subPages: Object.values(pageItem.subPages).map(generateNavigationItem),
    }),
  };
};

export const getGuardianPrimaryNavigation = (): IAppNavigationMenuItem[] => {
  const guardianPages = pages.guardian?.subPages;
  if (!guardianPages) return [];
  
  return [
    guardianPages.dashboard && generateNavigationItem(guardianPages.dashboard),
    guardianPages.academics && generateNavigationItem(guardianPages.academics),
    guardianPages.fees && generateNavigationItem(guardianPages.fees),
    guardianPages.transport && generateNavigationItem(guardianPages.transport),
    guardianPages.document && generateNavigationItem(guardianPages.document),
    guardianPages['events-communication'] && generateNavigationItem(guardianPages['events-communication']),
    guardianPages.concerns && generateNavigationItem(guardianPages.concerns),
  ].filter(Boolean) as IAppNavigationMenuItem[];
};

export const getGuardianSecondaryNavigation = (): IAppNavigationMenuItem[] => {
  const guardianPages = pages.guardian?.subPages;
  if (!guardianPages) return [];
  
  return [
    guardianPages.profile && generateNavigationItem(guardianPages.profile),
    guardianPages.settings && generateNavigationItem(guardianPages.settings),
    guardianPages.logout && generateNavigationItem(guardianPages.logout),
  ].filter(Boolean) as IAppNavigationMenuItem[];
};
